/* AMAR, il tasto "Credito Amar" (app Redeemly) non deve coprire le fasce fisse.

   Il tasto vive in uno shadow root (#mcb-launcher-widget-root), fisso in basso
   a destra: il CSS del tema non lo raggiunge. Questo script misura le fasce
   fisse in fondo allo schermo (la mensola del Diwan, la barra "Aggiungi al
   carrello" della pagina prodotto), scrive la loro altezza in --amar-lift su
   <html> e inietta nello shadow root una regola che alza il tasto di quella
   misura. Le variabili CSS attraversano lo shadow root, per questo funziona.
   Senza fasce visibili --amar-lift vale 0 e il tasto resta dov'e'. */
(function () {
  var ROOT_ID = 'mcb-launcher-widget-root';
  var STYLE_ID = 'amar-launcher-lift';
  var SELECTOR = '.dwn-tray__card, .sticky-add-to-cart__bar';
  var phone = window.matchMedia('(max-width: 989px)');
  var frame = 0;
  var burstUntil = 0;

  function inject() {
    var host = document.getElementById(ROOT_ID);
    if (!host || !host.shadowRoot) return false;
    if (host.shadowRoot.getElementById(STYLE_ID)) return true;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.launcher__floating-button{margin-bottom:var(--amar-lift,0px);' +
      'transition:margin-bottom .3s cubic-bezier(.16,1,.3,1),opacity .3s ease,transform .3s ease}';
    host.shadowRoot.appendChild(style);
    return true;
  }

  function measure() {
    frame = 0;
    inject();
    var vh = window.innerHeight;
    var top = vh;
    var bars = document.querySelectorAll(SELECTOR);
    for (var k = 0; k < bars.length; k++) {
      var el = bars[k];
      /* La mensola del Diwan e' fissa solo sotto i 990px. */
      if (el.classList.contains('dwn-tray__card') && !phone.matches) continue;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.top < vh - 1 && r.bottom > vh - 2) top = Math.min(top, r.top);
    }
    document.documentElement.style.setProperty('--amar-lift', Math.max(0, Math.round(vh - top)) + 'px');
    if (performance.now() < burstUntil) schedule();
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(measure);
  }

  /* Le barre entrano con una transizione: per mezzo secondo si misura a ogni
     fotogramma, cosi' il tasto le segue invece di saltare alla fine. */
  function burst() {
    burstUntil = performance.now() + 600;
    schedule();
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', burst);
  document.addEventListener('transitionstart', burst, true);
  document.addEventListener('transitionend', schedule, true);

  /* Il widget si monta dopo il caricamento della pagina: si riprova finche'
     non c'e', poi basta. */
  var tries = 0;
  var timer = setInterval(function () {
    if (inject() || ++tries > 60) clearInterval(timer);
    schedule();
  }, 500);

  schedule();
})();
